// extracted by mini-css-extract-plugin
export var container = "about-module--container--41d1b";
export var top = "about-module--top--786a4";